import React from "react";
import {
	Button,
	Card,
	CardBody,
	Container,
	CardHeader,
	Input,
	toast,
	MDBIcon,
} from "mdbreact";
import AccountTypesService from "./accountTypesService";
import { ToastContainer } from "react-toastify";
import ReactTooltip from "react-tooltip";

export default class addAccountType extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: "",
			errorMessage: "",
		};
	}

	nameChange = (e) => {
		this.setState({
			name: e.target.value,
		});
	};

	renderAddAccountButton() {
		return (
			<div>
				<p style={{ color: "red" }}>{this.state.errorMessage}</p>
				<Input
					label={"Account Type Name"}
					onChange={this.nameChange.bind(this)}
					value={this.state.name}
				/>
			</div>
		);
	}

	addSaveButtonClick = () => {
		if (this.validate()) {
			let obj = {
				name: this.state.name,
			};
			return AccountTypesService.createAccountType(obj)
				.then((res) => {
					this.setState({
						errorMessage: "",
						name: "",
					});
					toast.success(obj.name + " Account Type has been Added!");
				})
				.catch((err) => {
					toast.warn("An error occurred adding a new Account Type");
				});
		}
	};

	validate() {
		let n = this.state.name;
		if (n === "") {
			this.setError("Please enter an Account Name");
			return false;
		}
		return true;
	}
	setError(e) {
		this.setState({
			errorMessage: e,
		});
	}

	render() {
		return (
			<div>
				<ToastContainer
					hideProgressBar={false}
					newestOnTop={true}
					autoClose={3000}
				/>
				<Container className="mt-5">
					<Card>
						<CardHeader
							color={"blue-grey lighten-2"}
							style={{ textAlign: "center" }}
						>
							<Button
								style={{ float: "left" }}
								floating
								size="sm"
								color={"warning"}
								data-tip={"Back"}
								onClick={() => this.props.history.push("/accountTypes")}
							>
								<MDBIcon icon="backward" style={{ fontSize: "2em" }} />
							</Button>
							Add New Account Type
							<Button
								style={{ float: "right" }}
								floating
								size="sm"
								color={"success"}
								data-tip={"Save New Account Type"}
								onClick={this.addSaveButtonClick}
							>
								<MDBIcon far icon="save" style={{ fontSize: "2em" }} />
							</Button>
						</CardHeader>
						<CardBody>{this.renderAddAccountButton()}</CardBody>
					</Card>
					<ReactTooltip />
				</Container>
			</div>
		);
	}
}
